<template>
  <section>
    <NavBar />
    <section class="hero is-bold" :class="$style.customHero">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div id="textblock" class="column">
              <h2 class="title">Caracteristicas</h2>
              <p class="subtitle my-6">
                Datalized Connect, permite conectar los datos de tus servicios
                externos de CRM, RRHH, servicios contables y financieros a tu
                Base de Datos o Datawarehouse, facilitandote el acceso a
                información actualizada y empoderandote de tus datos
              </p>
            </div>
            <div class="column has-text-centered">
              <img
                :class="$style.heroImg"
                :src="heroImage"
                alt="hero"
                title="integrations hero"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container py-6" v-for="feature in features" :key="feature.id">
        <div class="column is-8">
          <h3 class="title my-5" :id="feature.hash">
            {{ feature.title }}
          </h3>
          <p class="subtitle my-5">
            {{ feature.subtitle }}
          </p>
        </div>
        <div class="columns is-vcentered">
          <div class="column is-2 has-text-centered">
            <img :src="feature.logo" alt="logo" />
          </div>
          <div class="column is-8">
            <ul
              class="$style.featuresList"
              v-for="item in feature.details"
              :key="item"
            >
              <li class="my-3 has-text-justified">
                <span class="icon">
                  <font-awesome-icon :icon="item.icon" />
                </span>
                {{ item.text }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </section>
</template>

<script>
import { NavBar, Footer } from "@/components";
import { heroFeature } from "@/assets/images";

import { features } from "@/utils";

export default {
  name: "Features",
  components: {
    NavBar,
    Footer,
  },
  data: () => {
    return {
      heroImage: heroFeature,
      features,
    };
  },
};
</script>

<style lang="scss" module>
.customHero {
  background: linear-gradient(
    0deg,
    rgba(27, 115, 232, 0.2) 0%,
    rgba(255, 255, 255, 0.1) 100%
  );
}

.heroImg {
  max-width: 42%;
}
</style>
